export default {
    root: {
        position: 'relative',
    },
};
